import { createApp } from "vue";
import App from "./App.vue";
import { bootstrap } from "./cool";
import "./cool/utils/number";
import createI18n from "./modules/i18n";
import getLanguage from "./utils/lang";
import I18NextVue from "i18next-vue";

const app = createApp(App);

async function start() {
	try {
		// 启动
		await bootstrap(app);
	} catch (err) {
		console.error("速哇3D摄影平台 启动失败", err);
	}

	try {
		// 加载语言数据失败时也不阻断主页面挂载
		const langExtraResp: any = await getLanguage();
		const i18n = createI18n(langExtraResp);
		app.use(I18NextVue, { i18next: i18n });
	} catch (err) {
		console.warn("语言包加载失败，使用默认配置继续启动", err);
		const i18n = createI18n({});
		app.use(I18NextVue, { i18next: i18n });
	}

	app.mount("#app");
}

start();
